import React from "react";

import { FooterStyle } from "./styles";

function Footer() {
  return (
    <FooterStyle>
      <div className="text-dark order-2 order-md-1">
        <span className="text-muted font-weight-bold mr-2">
          {new Date().getFullYear()} spread.chat
        </span>
      </div>
    </FooterStyle>
  );
}

export default Footer;
